import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RedirectService {

    constructor(
        private _router: Router
    ) { }

    redirectBasedOnRoles() {
        let role = localStorage.getItem('userRole');

        if (role === 'webAdmin') {
            this._router.navigateByUrl('/dashboard');
        } else if (role === 'supervisor') {
            this._router.navigateByUrl('/dashboard');
        } else if (role === 'rbaAdmin') {
            this._router.navigateByUrl('/teamsList');
        } else {
            this._router.navigateByUrl('/signin');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/redirect/redirect.service.ts